
    import { Component,Vue } from 'vue-property-decorator'
    import { State,Action,namespace,Getter} from 'vuex-class'
    const site = namespace('site')
    const packageslist = namespace('packageslist')
    @Component
    export default class Aside extends Vue{
        lookApp:Boolean = false
        @State('baseInfo') baseInfo:any
        @State('newWaterStatus') newWaterStatus:any
        @site.State('info') info:any
        @Getter('water') moneytype:any
        get defaultActive(){
            const route = this.$route.path.split('/')[1]
            return '/' + route
        }
        @Action('getNewWaterStatus') getNewWaterStatus:any
        @packageslist.Action('getTreaTmentNum') getTreaTmentNum: any
        @packageslist.State('tmentNum') tmentNum: Number
        async created(){
            await this.getNewWaterStatus()
            await  this.getTreaTmentNum()
            if(this.tmentNum > 0){
                this.open();
            }
        }
        lookAppQs(){
            this.lookApp = true
        }
        handleSelect(key:string, keyPath:string){
            this.$router.push(key)
        }
        open() {
            this.$confirm(`您有${this.tmentNum}个滞留件需要处理?`, '请及时处理', {
                confirmButtonText: '马上处理',
                cancelButtonText: '等会儿处理',
                distinguishCancelAndClose: true,
                type: 'warning',
                center: true
            }).then(() => {
                this.$router.push('/treatment');
            }).catch(() => {

            });
        }
        exit(){
            this.$confirm('确定需要退出登陆吗?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                localStorage.removeItem('token')
                this.$router.push('/login')
            }).catch(() => {
                
            })
        }
    }
